import isNil from 'lodash/isNil';
import has from 'lodash/has';
import { useSelector } from 'react-redux';
import { mapValues, pick } from 'lodash';
import { getResourceEntity } from '../../../../../../../js/lib/PipelineUtils';

export function useReplicationFlow(flowId: number | string) {
  const { branches, edges } = useSelector((state: any) => state.pipelines);
  const entities = useSelector((state: any) => state.entities);

  if (!flowId) {
    return null;
  }

  const { flowNodes } = entities;
  const branch =
    !isNil(flowId) && has(branches, flowId) ? branches[flowId] : { items: [], edges: [] };

  const pipelineItems = mapValues(pick(flowNodes, branch.items), (flowNode) =>
    getResourceEntity(flowNode, entities),
  );

  const flow = flowNodes[flowId] || {};

  return Object.values(pipelineItems).reduce(
    (resources, item) => {
      if (item.type === 'SOURCE') {
        resources.source = item;
      }
      if (item.type === 'DATA_SINK') {
        resources.destination = item;
      }
      if (item.type === 'DATA_SET') {
        resources.nexset = item;
      }
      return resources;
    },
    { flow, nexset: {} },
  );
}
